import * as yup from 'yup'

export default yup.object().shape({
  email: yup.string().required('Required field'),
  password: yup.string().required('Required field'),
})
